"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Button2 = _interopRequireDefault(require("@material-ui/core/Button"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Button = (0, _styles.withStyles)(function () {
  return {
    root: {
      textTransform: "none",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none"
      }
    },
    textSizeSmall: {
      padding: "4px 10px"
    }
  };
})(_Button2["default"]);
var _default = Button;
exports["default"] = _default;